import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTORS_QUERY_KEYS } from "Actors/Api/Queries/queryKeys";
import { deleteActorsActorIDDocumentsActorDocumentID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export function useDeleteActorDocumentMutation(actorID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((actorDocumentID: string) =>
      deleteActorsActorIDDocumentsActorDocumentID(actorID, actorDocumentID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.documents(actorID),
      });
    },
  });
}
